<template>
    <transition appear name="fade" mode="out-in">
        <div v-if="active" class="ui-modal-message-wrapper">
            <div class="ui-modal-message">
                <h1>{{ title || 'Nachrichtentitel' }}</h1>
                <p v-html="message || 'Nachrichtentext'"></p>
                <div class="ui-modal-buttons">
                    <template v-if="'simple' === mode">
                        <div class="ui-modal-button cancel" @click="cancel">
                            abbrechen
                        </div>
                        <div class="ui-modal-button submit" @click="approve">
                            ja
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'ModalDialog',
    data()
    {
        return {
            active:    false,
            title:     false,
            message:   false,
            mode:      'simple',
            modalUuid: false
        }
    },
    
    created() {
        
        this.$core
            .getEventManager()
            .add( 'on-modal-dialog', ( setup ) => {
                
                this.active = true
                this.title = setup.title
                this.message = setup.text
                this.mode = setup.mode
                this.modalUuid = setup.modalUuid
                
            } )
        
    },
    
    beforeUnmount() {
        
        this.$core
            .getEventManager()
            .remove( 'on-modal-dialog' )
        
    },
    
    methods: {
        
        reset()
        {
            this.active = false
            this.title = false
            this.message = false
            this.mode = 'simple'
            this.modalUuid = false
        },
        
        cancel() {
            
            this.$core
                .getEventManager()
                .dispatchAndRemove( 'on-modal-cancel-' + this.modalUuid )
            
            this.reset()
            
        },
        
        approve()
        {
            
            this.$core
                .getEventManager()
                .dispatchAndRemove( 'on-modal-approve-' + this.modalUuid )
            
            this.reset()
            
        }
    }
}
</script>